import {TimelineMax, TweenLite} from 'gsap';
import {mapState} from 'vuex';
const SplitText = require('../../../../viscomjs/utils/SplitText');
const SyncXBehavior = require('../../behaviors/SyncXBehavior');
const elementsTracking = require('../../../../viscomjs/analytics/elementsTracking');
const win = window;

export default {
    name: 'app-404',
    props: {
        data: Object
    },
    computed: {
        ...mapState('menu', {
            menuOn: state => state.open
        }),
        visibility() {
            return !this.menuOn && this.entered;
        }
    },
    data() {
        return {
            entered: false,
            transitionName: 'in',
            ttlVisible: '',
            subVisible: ''
        };
    },
    mounted() {
        SplitText.wrapSymbols([this.$el.querySelector('.app-cover__ttl')], {
            cssProperty: 'transition',
            center: true,
            reverse: true,
            factor: 2,
            durationRatio: 1,
            durationMax: 1.25,
            durationMin: 0.85,
            nestingNum: 2,
            timingNestingLevel: 1
        });
        SplitText.wrapSymbols([this.$el.querySelector('.app-cover__sub')], {
            cssProperty: 'transition',
            center: true,
            factor: 1,
            durationRatio: 0.2,
            durationMax: 1.0,
            durationMin: 0.5,
            nestingNum: 2,
            timingNestingLevel: 1
        });

        const els = [...this.$el.querySelectorAll('[data-sync-position-root]')];
        this.bgResizeBehaviors = els.map(el => SyncXBehavior(el));

        this.startResize();
        this.entered = true;

        this.startAnalytics();
    },
    beforeDestroy() {
        this.destroyAnalytics();
        this.stopResize();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.transitionName = 'in';
            vm.entered = true;
        });
    },
    beforeRouteLeave(to, from, next) {
        this.transitionName = 'out';
        this.entered = false;
        this.hide();
        TweenLite.delayedCall(0.5, next);
    },
    watch: {
        menuOn() {
            this.transitionName = 'out';
        },
        visibility(to, from) {
            console.log('animate visibility from', from, 'to', to);
            if (to) this.show();
            else this.hide();
        }
    },
    methods: {
        onGo() {
            this.$store.dispatch('menu/open');
        },
        show() {
            const tl = new TimelineMax();
            tl.addLabel('st');
            tl.call(this.setTtlVisible, [], this, 'st+=' + 0.5);
            tl.call(this.setSubVisible, [], this, 'st+=' + 0.65);
        },
        hide() {
            const tl = new TimelineMax();
            tl.addLabel('st');
            tl.call(this.setSubInvisible, [], this, 'st+=' + 0.01);
            tl.call(this.setTtlInvisible, [], this, 'st+=' + 0.15);
        },
        setTtlVisible() {
            this.ttlVisible = 'active';
        },
        setSubVisible() {
            this.subVisible = 'active';
        },
        setTtlInvisible() {
            this.ttlVisible = '';
        },
        setSubInvisible() {
            this.subVisible = '';
        },
        startResize() {
            this.resize();
            win.addEventListener('resize', this.resize);
        },
        stopResize() {
            win.removeEventListener('resize', this.resize);
        },
        resize() {
            this.bgResizeBehaviors.forEach(bvr => {
                bvr.invalidate();
            });
        },
        startAnalytics() {
            elementsTracking.init(this.$el);
        },
        destroyAnalytics() {
            elementsTracking.destroy(this.$el);
        }
    },
    template: require('../../../../../../templates/app-404.pug')
};
